import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import MerchandiseModule from '@/modules/merchandise';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/merchandise')({
  component: MerchandisePage,
});

function MerchandisePage() {
  const { canAccessGlobalLeaderboard } = useAccessControl();

  if (!canAccessGlobalLeaderboard) {
    return <AccessDenied />;
  }

  return <MerchandiseModule />;
}
